// Authentication roles
export const AUTH_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  REVIEWER: 'reviewer'
};

// Route namespaces for different roles
export const ROUTE_NAMESPACES = {
  ADMIN: '/admin',
  REVIEWER: '/reviewer',
  USER: '/' // Default user routes
};

// Token storage keys
export const TOKEN_KEYS = {
  USER_ACCESS_TOKEN: 'USER_ACCESS_TOKEN',
  ADMIN_ACCESS_TOKEN: 'ADMIN_ACCESS_TOKEN',
  REVIEWER_ACCESS_TOKEN: 'REVIEWER_ACCESS_TOKEN',
  USER_REFRESH_TOKEN: 'USER_REFRESH_TOKEN',
  ADMIN_REFRESH_TOKEN: 'ADMIN_REFRESH_TOKEN',
  REVIEWER_REFRESH_TOKEN: 'REVIEWER_REFRESH_TOKEN',
  AUTH_ROLE: 'AUTH_ROLE'
};

// Login routes for each role
export const LOGIN_ROUTES = {
  [AUTH_ROLES.USER]: '/login',
  [AUTH_ROLES.ADMIN]: '/admin/login',
  [AUTH_ROLES.REVIEWER]: '/reviewer/login'
};

// Dashboard routes for each role
export const DASHBOARD_ROUTES = {
  [AUTH_ROLES.USER]: '/',
  [AUTH_ROLES.ADMIN]: '/admin',
  [AUTH_ROLES.REVIEWER]: '/reviewer'
};
